<template>
  <figure class="image__wrapper" v-lazyload ref="imageItem" v-if="source">
    <span class="preloader" v-if="preloader"></span>
    <img
        class="image__item"
        :data-url="source"
    >
    <span v-if="custom && custom.group" class="group" @click.stop="openLink">
      Gr. {{ custom.group }}
    </span>
  </figure>
</template>

<script>
export default {
  name: "ImageItem",
  props: {
    source: {
      type: String,
      required: true
    },
    custom: {
      type: Object
    }
  },
  data() {
    return {
      preloader: true
    }
  },
  methods: {
    onClassChange(classAttrValue) {
      const classList = classAttrValue.split(' ');
      if (classList.includes('loaded')) {
        this.preloader = false
      }
    },
    openLink () {
      window.open('https://ramaro.pl/grupy-tkanin/', '_blank').focus();
    }
  },
  mounted() {
    this.observer = new MutationObserver(mutations => {
      for (const m of mutations) {
        const newValue = m.target.getAttribute(m.attributeName);
        this.$nextTick(() => {
          this.onClassChange(newValue, m.oldValue);
        });
      }
    });

    this.observer.observe(this.$refs.imageItem, {
      attributes: true,
      attributeOldValue : true,
      attributeFilter: ['class'],
    });
  },
  beforeDestroy() {
    this.observer.disconnect();
  },
};
</script>

<style scoped lang="scss">
figure {
  padding: 0;
  margin: 0;

  position: relative;

  img {
    position: relative;
  }

  .preloader {
    width: 100%;
    height: 100%;
    border-radius: 100%;
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    background: #eee;
    animation: pulse 2s infinite;
    z-index: 1;
  }

  @keyframes pulse {
    0% {
      opacity: .75;
    }

    70% {
      opacity: 1;
    }

    100% {
      opacity: .75;
    }
  }

  .group {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    display: inline-flex;
    width: 34px;
    height: 15px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 2px;
    font-weight: 600;
    font-size: 10px;
    text-align: center;
    letter-spacing: 0.4px;
    color: #3C3C3C;
    align-items: center;
    justify-content: center;
    padding-bottom: 2px;
    cursor: pointer;
  }
}

.is-tooltip {
  position: relative; /* making the .tooltip span a container for the tooltip text */
  &:before {
    content: attr(data-tooltip); /* here's the magic */
    position: absolute;
    height: 15px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 2px;
    font-weight: 600;
    font-size: 11px;
    text-align: center;
    letter-spacing: 0.4px;
    color: #3C3C3C;
    align-items: center;
    justify-content: center;
    display: inline-flex;
    opacity: 0;
    margin-bottom: -5px;
    transition: all .2s;
    padding: 0 3px;
  }

  &:hover:before {
    opacity: 1;
    margin-bottom: 40px;
  }
}
</style>
